import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth, UserRole } from '@services/auth';

type RequireAuthProps = {
	allowedRoles?: UserRole[];
	redirectTo?: string;
};

export default function RequireAuth({ allowedRoles, redirectTo = '/login' }: RequireAuthProps) {
	const { user, isReady } = useAuth();
	const location = useLocation();

	if (!isReady) {
		return null;
	}

	if (!user) {
		return <Navigate to={redirectTo} replace state={{ from: location }} />;
	}

	if (allowedRoles && !allowedRoles.includes(user.role)) {
		return <Navigate to="/app/dashboard" replace />;
	}

	return <Outlet />;
}


